/**
 * PerformanceOptimizer — lazy loading via IntersectionObserver.
 * Migrated from dpss-theme.js lines 642-688.
 */

export class PerformanceOptimizer {
  constructor() {
    this.init();
  }

  private init(): void {
    this.initLazyLoading();
    this.initScrollOptimization();
  }

  private initLazyLoading(): void {
    if (!("IntersectionObserver" in window)) return;

    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.add("loaded");
            imageObserver.unobserve(img);
          }
        }
      });
    });

    document.querySelectorAll("img[data-src]").forEach((img) => {
      imageObserver.observe(img);
    });
  }

  private initScrollOptimization(): void {
    let ticking = false;

    function updateScrollPosition() {
      ticking = false;
    }

    window.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(updateScrollPosition);
        ticking = true;
      }
    });
  }
}
